export default "__VITE_ASSET__BtUMKNRe__"